// extracted by mini-css-extract-plugin
export var connectionButton = "_4s-1";
export var rightPanel = "_4s-3";
export var stepDescription = "_4s-2";
export var stepIcon = "_4s-0";